import type { SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'NG Painting Pro',
    description: 'Licensed and insured painters in New Bedford, MA. Interior, exterior, commercial and industrial painting since 2000. Call 774-301-1382 for a free estimate.',
    placeholder: 'Your new site will appear right here. Just ask Modulify to generate anything you can describe.',
    url: 'https://ngpaintingpro.modulify.website',
    phone: '774-301-1382',
    phoneHref: 'tel:+17743011382',
    email: 'ngpaintingpro1@gmail.com',
    hours: 'Mon to Sat, 7am to 9pm',
    address: 'New Bedford, MA, United States',
    mapUrl: 'https://maps.google.com/?q=New+Bedford,+MA',
    ogImage: '/images/ng/hero-house-new-bedford.webp'
}
